/* Cart "upgrade & save" drawer behavior. Loaded once per page (deferred)
   from layout/theme.liquid — NOT inline in cart-drawer.liquid, because the
   cart drawer's HTML is replaced via innerHTML on every cart update
   (Section Rendering API), which does not re-execute embedded scripts. All
   interaction is document-delegated, so a single page-level load survives
   those swaps. Reads #UpgradeDrawer (present sitewide); needs `defer`
   (not `async`) — its one top-level getElementById has no observer fallback.
   Pure behavior: no Liquid values (product data arrives via data-* attrs and
   a runtime /products/<handle>.js fetch). */
  (function() {
    var drawer = document.getElementById('UpgradeDrawer');
    if (!drawer) return;

    var overlay = drawer.querySelector('.upgrade-drawer__overlay');
    var body = drawer.querySelector('.upgrade-drawer__body');
    var savingsBanner = drawer.querySelector('.upgrade-drawer__savings-banner');
    var backBtns = drawer.querySelectorAll('.upgrade-drawer__back, .upgrade-drawer__btn--secondary');
    var upgradeBtn = drawer.querySelector('.upgrade-drawer__btn--primary');

    var currentProduct = null;
    var selectedVariantId = null;
    var parentLineKey = null;
    var parentVariantId = null;
    var swatchColorMap = {};
    /* Cache metafield images per variant so we don't re-fetch on repeat visits */
    var metafieldImageCache = {};

    function formatMoney(cents) {
      if (window.Shopify && window.Shopify.formatMoney) {
        return Shopify.formatMoney(cents).replace(/\.00$/, '');
      }
      return '₹' + (cents / 100).toLocaleString('en-IN');
    }

    function starsSVG() {
      var full = '<svg width="16" height="16" viewBox="0 0 24 24" fill="#004E32" xmlns="http://www.w3.org/2000/svg"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
      var half = '<svg width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><defs><linearGradient id="ud-half"><stop offset="80%" stop-color="#004E32"/><stop offset="80%" stop-color="#D9D9D9"/></linearGradient></defs><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="url(#ud-half)"/></svg>';
      return full + full + full + full + half;
    }

    /* ── Fetch variant-level metafield images (custom.cart_upgrade_images)
          via section rendering API. Returns an array of {src, thumb, alt} or
          empty array if the variant has no metafield data. Falls back to
          default product images in that case. ── */
    function fetchUpgradeImages(productHandle, variantId) {
      if (metafieldImageCache[variantId]) {
        return Promise.resolve(metafieldImageCache[variantId]);
      }
      var root = window.Shopify.routes.root || '/';
      var url = root + 'products/' + productHandle + '?variant=' + variantId + '&section_id=cart-upgrade-images';
      return fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var script = doc.querySelector('[data-upgrade-images]');
          if (!script) return [];
          try {
            var imgs = JSON.parse(script.textContent.trim());
            metafieldImageCache[variantId] = imgs;
            return imgs;
          } catch (e) {
            return [];
          }
        })
        .catch(function () { return []; });
    }

    /* Replace the gallery + thumbnails with metafield images. If the
       metafield is empty, fall back to product.images (variant-filtered).
       Gallery is a horizontal scroll-snap carousel. */
    function applyUpgradeImages(images) {
      var track = body.querySelector('.upgrade-drawer__gallery-track');
      var thumbsContainer = body.querySelector('.upgrade-drawer__thumbs');

      /* If metafield has no images, fall back to product.images */
      if ((!images || !images.length) && currentProduct) {
        var variant = getVariant(currentProduct, selectedVariantId);
        var fallbackImages = [];
        if (variant.featured_image) {
          fallbackImages.push({
            src: variant.featured_image.src,
            thumb: variant.featured_image.src.replace(/(\.\w+)(\?|$)/, '_200x200$1$2'),
            alt: variant.title
          });
        }
        currentProduct.images.forEach(function (img) {
          if (!variant.featured_image || img !== variant.featured_image.src) {
            fallbackImages.push({
              src: img,
              thumb: img.replace(/(\.\w+)(\?|$)/, '_200x200$1$2'),
              alt: currentProduct.title
            });
          }
        });
        images = fallbackImages;
      }

      if (!images || !images.length || !track) return;

      /* Build scrollable gallery slides */
      var slidesHtml = '';
      images.forEach(function (img) {
        slidesHtml += '<div class="upgrade-drawer__gallery-slide">';
        slidesHtml += '<img src="' + img.src + '" alt="' + (img.alt || '') + '" />';
        slidesHtml += '</div>';
      });
      track.innerHTML = slidesHtml;

      /* Build thumbnails */
      if (images.length > 1 && thumbsContainer) {
        var thumbsHtml = '';
        images.forEach(function (img, i) {
          var activeClass = i === 0 ? ' is-active' : '';
          thumbsHtml += '<button type="button" class="upgrade-drawer__thumb' + activeClass + '" data-thumb-index="' + i + '">';
          thumbsHtml += '<img src="' + img.thumb + '" alt="' + (img.alt || '') + '" />';
          thumbsHtml += '</button>';
        });
        thumbsContainer.innerHTML = thumbsHtml;
        thumbsContainer.style.display = '';

        /* Sync: scroll gallery → update active thumb via scroll position */
        var slides = track.querySelectorAll('.upgrade-drawer__gallery-slide');
        function syncThumbToScroll() {
          var slideWidth = track.offsetWidth;
          if (!slideWidth) return;
          var activeIdx = Math.round(track.scrollLeft / slideWidth);
          thumbsContainer.querySelectorAll('.upgrade-drawer__thumb').forEach(function (t, i) {
            t.classList.toggle('is-active', i === activeIdx);
          });
        }
        track.addEventListener('scroll', syncThumbToScroll, { passive: true });

        /* Sync: click thumb → scroll gallery */
        thumbsContainer.querySelectorAll('.upgrade-drawer__thumb').forEach(function (thumb) {
          thumb.addEventListener('click', function () {
            var idx = parseInt(thumb.getAttribute('data-thumb-index'), 10);
            var slideWidth = track.offsetWidth;
            track.scrollTo({ left: idx * slideWidth, behavior: 'smooth' });
          });
        });
      } else if (thumbsContainer) {
        thumbsContainer.innerHTML = '';
        thumbsContainer.style.display = 'none';
      }
    }

    /* ── Open drawer ── */
    function openDrawer(productHandle, lineKey, parentVId, swatchColors, customTitle) {
      parentLineKey = lineKey;
      parentVariantId = parentVId;
      swatchColorMap = swatchColors || {};

      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      body.innerHTML = '<div style="display:flex;align-items:center;justify-content:center;height:200px;"><p>Loading...</p></div>';

      fetch((window.Shopify.routes.root || '/') + 'products/' + productHandle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(product) {
          currentProduct = product;
          selectedVariantId = product.variants[0].id;
          // Override product.title with the custom metafield value if the
          // trigger button supplied one (Liquid has already resolved
          // product.metafields.custom.custom_product_title | default: product.title).
          if (customTitle) product.title = customTitle;
          renderDrawer(product);
        })
        .catch(function(err) {
          console.error('Upgrade drawer fetch error:', err);
          body.innerHTML = '<div style="padding:2rem;text-align:center;"><p>Failed to load product</p></div>';
        });
    }

    /* ── Close drawer ── */
    function closeDrawer() {
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      currentProduct = null;
      selectedVariantId = null;
      parentLineKey = null;
      upgradeBtn.textContent = 'Upgrade';
      upgradeBtn.disabled = false;
    }

    /* ── Render product inside drawer ── */
    function renderDrawer(product) {
      var variant = getVariant(product, selectedVariantId);
      var price = variant.price;
      var compareAt = variant.compare_at_price;
      var discountPct = compareAt && compareAt > price ? Math.round((compareAt - price) / compareAt * 100) : 0;
      var savings = compareAt && compareAt > price ? compareAt - price : 0;

      var html = '';

      /* Product info */
      html += '<div class="upgrade-drawer__product-info">';
      html += '<p class="upgrade-drawer__title">' + product.title + '</p>';
      html += '<div class="upgrade-drawer__rating">';
      html += '<div class="upgrade-drawer__stars">' + starsSVG() + '</div>';
      html += '<span class="upgrade-drawer__rating-text">4.8</span>';
      html += '<span class="upgrade-drawer__rating-dot">&middot;</span>';
      html += '<span class="upgrade-drawer__rating-reviews">30 Reviews</span>';
      html += '</div>';
      html += '<div class="upgrade-drawer__price-row">';
      html += '<span class="upgrade-drawer__price">' + formatMoney(price) + '</span>';
      if (compareAt && compareAt > price) {
        html += '<span class="upgrade-drawer__mrp">MRP ' + formatMoney(compareAt) + '</span>';
        html += '<span class="upgrade-drawer__discount-badge">' + discountPct + '% OFF</span>';
      }
      html += '</div>';
      html += '<p class="upgrade-drawer__tax">(incl. of taxes)</p>';
      html += '</div>';

      /* Gallery + thumbnails shimmer placeholders. applyUpgradeImages()
         replaces these with the actual variant metafield images. */
      html += '<div class="upgrade-drawer__gallery">';
      html += '<div class="upgrade-drawer__gallery-track">';
      html += '<div class="upgrade-drawer__gallery-slide upgrade-drawer__gallery-shimmer"></div>';
      html += '</div>';
      html += '</div>';

      html += '<div class="upgrade-drawer__thumbs">';
      for (var si = 0; si < 4; si++) {
        html += '<div class="upgrade-drawer__thumb upgrade-drawer__thumb-shimmer"></div>';
      }
      html += '</div>';

      html += '<div class="upgrade-drawer__divider"></div>';

      /* Variant picker — color options */
      if (product.options && product.options.length > 0) {
        product.options.forEach(function(option, optIndex) {
          var optionName = option.name || option;
          /* Get unique values for this option */
          var values = [];
          var seen = {};
          product.variants.forEach(function(v) {
            var val = v.options[optIndex];
            if (!seen[val]) {
              seen[val] = true;
              values.push(val);
            }
          });

          html += '<div class="upgrade-drawer__variants">';
          html += '<p class="upgrade-drawer__variant-label">Choose ' + optionName + ': <strong>' + variant.options[optIndex] + '</strong></p>';
          html += '<div class="upgrade-drawer__swatches">';

          values.forEach(function(val) {
            var isActive = val === variant.options[optIndex] ? ' is-active' : '';
            /* Try to use color swatch */
            var isColor = /color|colour/i.test(optionName);
            if (isColor) {
              /* Use swatch colors from Shopify's native swatch data (passed via
                 data-swatch-colors on the trigger button, rendered from Liquid). */
              var bgColor = swatchColorMap[val] || swatchColorMap[val.toLowerCase()] || '#ccc';
              html += '<button type="button" class="upgrade-drawer__swatch' + isActive + '" data-option-index="' + optIndex + '" data-option-value="' + val + '">';
              html += '<span class="upgrade-drawer__swatch-color" style="background:' + bgColor + '"></span>';
              html += '</button>';
            } else {
              html += '<button type="button" class="upgrade-drawer__swatch' + isActive + '" data-option-index="' + optIndex + '" data-option-value="' + val + '" style="width:auto;height:auto;padding:0.6rem 1.2rem;font-family:var(--font-jakarta-regular);font-size:1.2rem;border:1px solid #ccc;">';
              html += val;
              html += '</button>';
            }
          });

          html += '</div></div>';
        });
      }

      body.innerHTML = html;

      /* Fetch variant-level metafield images and replace the gallery
         if data exists. Falls back to the product images already rendered. */
      fetchUpgradeImages(product.handle, selectedVariantId).then(applyUpgradeImages);

      /* Savings banner */
      if (savings > 0) {
        savingsBanner.style.display = 'flex';
        savingsBanner.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="#004E32" xmlns="http://www.w3.org/2000/svg"><path d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z"/></svg>'
          + '<span>You Save Upto ' + formatMoney(savings) + ' extra by upgrading</span>';
      } else {
        savingsBanner.style.display = 'none';
      }

      /* Thumbnail clicks are now handled inside applyUpgradeImages() */

      /* Bind swatch clicks */
      body.querySelectorAll('.upgrade-drawer__swatch').forEach(function(swatch) {
        swatch.addEventListener('click', function() {
          var optIndex = parseInt(swatch.getAttribute('data-option-index'), 10);
          var optValue = swatch.getAttribute('data-option-value');

          /* Find matching variant */
          var currentVariant = getVariant(product, selectedVariantId);
          var newOptions = currentVariant.options.slice();
          newOptions[optIndex] = optValue;

          var match = product.variants.find(function(v) {
            return v.options.every(function(o, i) { return o === newOptions[i]; });
          });

          if (!match) {
            /* Fallback: find first variant with this option value */
            match = product.variants.find(function(v) { return v.options[optIndex] === optValue; });
          }

          if (match) {
            selectedVariantId = match.id;
            renderDrawer(product);
          }
        });
      });
    }

    function getVariant(product, variantId) {
      return product.variants.find(function(v) { return v.id === variantId; }) || product.variants[0];
    }

    /* ── Upgrade action ── */
    function doUpgrade() {
      if (!selectedVariantId || !parentLineKey) return;

      upgradeBtn.disabled = true;
      upgradeBtn.textContent = 'Upgrading...';

      var root = window.Shopify.routes.root || '/';

      /* Step 1: Remove parent line item */
      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parentLineKey, quantity: 0 })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        /* Step 2: Add upgrade product */
        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        var sections = cart && cart.getSectionsToRender ? cart.getSectionsToRender().map(function(s) { return s.id; }) : [];

        var addBody = {
          items: [{
            id: selectedVariantId,
            quantity: 1,
            properties: {
              '__source': 'cart-drawer-upgrade',
              'Upgraded From URL': window.location.pathname
            }
          }]
        };
        if (sections.length) {
          addBody.sections = sections;
          addBody.sections_url = window.location.pathname;
        }

        return fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(addBody)
        }).then(function(r) { return r.json(); })
        .then(function(response) {
          if (response.status) {
            upgradeBtn.textContent = 'Error';
            setTimeout(function() { upgradeBtn.textContent = 'Upgrade'; upgradeBtn.disabled = false; }, 2000);
            return;
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'upgrade-drawer',
              productVariantId: selectedVariantId,
              cartData: response
            });
          }

          closeDrawer();

          if (cart && cart.renderContents) {
            cart.renderContents(response);
          }
        });
      })
      .catch(function(err) {
        console.error('Upgrade error:', err);
        upgradeBtn.textContent = 'Upgrade';
        upgradeBtn.disabled = false;
      });
    }

    /* ── Event listeners ── */

    /* Open trigger (event delegation — survives DOM replacement) */
    document.addEventListener('click', function(e) {
      var trigger = e.target.closest('[data-upgrade-drawer-trigger]');
      if (!trigger) return;
      if (trigger.disabled || trigger.getAttribute('aria-disabled') === 'true') return;
      var swatchColors = {};
      try { swatchColors = JSON.parse(trigger.getAttribute('data-swatch-colors') || '{}'); } catch (err) {}
      openDrawer(
        trigger.getAttribute('data-product-handle'),
        trigger.getAttribute('data-parent-line-key'),
        trigger.getAttribute('data-parent-variant-id'),
        swatchColors,
        trigger.getAttribute('data-custom-title') || ''
      );
    });

    /* Close */
    overlay.addEventListener('click', closeDrawer);
    backBtns.forEach(function(btn) { btn.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') closeDrawer();
    });

    /* Upgrade */
    upgradeBtn.addEventListener('click', doUpgrade);
  })();
